import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding: ${props => (props.withPadding ? 80 : 0)}px 0 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
